module.exports = __webpack_public_path__ + "img/tiger.514325bf.svg";